function initialState() {
    return {
        id: -1,
        login: "",
        messages: 0,
        orderlist: []
    };
}


const state = initialState();

// getters
const getters = {
    id: (state, getters) => {
        return state.id;
    },

    login: (state, getters) => {
        return state.login;
    },

    isLoggedIn: (state, getters) => {
        return state.id >= 0;
    },

    messages: (state, getters) => {
        return state.messages;
    },

    orderlist: (state) => (type) => {
        return state.orderlist[type];
    },
}

// actions
const actions = {
}

// mutations
const mutations = {

    login(state, obj) {
        state.id = obj.id;
        state.login = obj.login;
        state.orderlist = obj.orderlist;
        state.messages = obj.messages;
    },

    setMessages(state, count) {
        state.messages = count;
    },

    readMessage(state, count) {
        state.messages--;
    },

    logout(state) {
        Object.assign(state, initialState());
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js